module.exports = __webpack_public_path__ + "static/media/arctic_fauna.5a3c739e.jpg";